const assignments = [
  {
    id: 2835,
    requisitionNumber: "RQ02835",
    title: "Registered Nurse - Medical/Surgical",
    profession: "RN",
    facility: "Nova Scotia Health",
    province: "Nova Scotia",
    city: "Yarmouth",
    unit: "Medical/Surgical",
    shift: "Various",
    pay: null,
    payDisplay: "Rate available upon offer",
    status: "New",
    startDate: "2026-10-01",
    endDate: "2026-11-30",
    closingDate: "2026-08-13T16:00:00-03:00",
    clientTitle: "Acute Care - YRH extension",
    description:
      "Travel nursing opportunity in a Medical/Surgical acute care setting in Yarmouth, Nova Scotia. Zeth Health will provide the final compensation package, schedule and onboarding details to qualified applicants.",
    requirements: [
      "Current Registered Nurse licence or eligibility for registration in Nova Scotia",
      "Recent Medical/Surgical or acute care nursing experience",
      "Current BLS certification",
      "Current immunization and occupational health documentation",
      "Vulnerable Sector Check / Criminal Record Check as required",
      "Additional facility-specific onboarding requirements will be confirmed by Zeth Health",
    ],
  },

  {
    id: 2826,
    requisitionNumber: "RQ02826",
    title: "Registered Nurse - Emergency Department",
    profession: "RN",
    facility: "Cape Breton Regional Hospital",
    province: "Nova Scotia",
    city: "Sydney",
    unit: "Emergency Department",
    shift: "Various",
    pay: null,
    payDisplay: "Rate available upon offer",
    status: "Urgent",
    startDate: "2026-10-08",
    endDate: "2026-11-22",
    closingDate: "2026-08-13T12:00:00-03:00",
    clientTitle: "Emergency Department",
    description:
      "Travel nursing opportunity in the Emergency Department at Cape Breton Regional Hospital. Zeth Health will confirm the final compensation package, schedule and onboarding requirements before placement.",
    requirements: [
      "Current Nova Scotia RN licence or eligibility for registration",
      "Minimum recent Emergency Department experience",
      "BLS",
      "ACLS",
      "CTAS",
      "TNCC",
      "PALS or ENPC",
      "Current immunization and occupational health documentation",
      "Vulnerable Sector Check / Criminal Record Check",
      "Additional Nova Scotia Health onboarding documents as required",
    ],
  },

  {
    id: 2827,
    requisitionNumber: "RQ02827",
    title: "Registered Nurse - Emergency Department",
    profession: "RN",
    facility: "Cape Breton Regional Hospital",
    province: "Nova Scotia",
    city: "Sydney",
    unit: "Emergency Department",
    shift: "Various",
    pay: null,
    payDisplay: "Rate available upon offer",
    status: "New",
    startDate: "2026-10-01",
    endDate: "2026-10-31",
    closingDate: "2026-08-17T12:00:00-03:00",
    clientTitle: "Emergency Department",
    description:
      "Travel nursing opportunity in the Emergency Department at Cape Breton Regional Hospital. Zeth Health will confirm the final compensation package, schedule and onboarding requirements before placement.",
    requirements: [
      "Current Nova Scotia RN licence or eligibility for registration",
      "Minimum recent Emergency Department experience",
      "BLS",
      "ACLS",
      "CTAS",
      "TNCC",
      "PALS or ENPC",
      "Current immunization and occupational health documentation",
      "Vulnerable Sector Check / Criminal Record Check",
      "Additional Nova Scotia Health onboarding documents as required",
    ],
  },

  {
    id: 2836,
    requisitionNumber: "RQ02836",
    title: "Registered Nurse - Intensive Care Unit",
    profession: "RN",
    facility: "Nova Scotia Health",
    province: "Nova Scotia",
    city: "Yarmouth",
    unit: "Intensive Care Unit",
    shift: "Various",
    pay: null,
    payDisplay: "Rate available upon offer",
    status: "Urgent",
    startDate: "2026-10-01",
    endDate: "2026-11-30",
    closingDate: "2026-08-13T12:00:00-03:00",
    clientTitle: "ICU YRH - extending",
    description:
  "Travel nursing opportunity in the Intensive Care Unit in Yarmouth, Nova Scotia. Zeth Health will provide the final compensation package, schedule and onboarding requirements to qualified applicants.",
    requirements: [
      "Current Nova Scotia RN licence or eligibility for registration",
      "Recent ICU / critical care nursing experience",
      "BLS",
      "ACLS",
      "TNCC",
      "PALS or ENPC where required",
      "Current immunization and occupational health documentation",
      "Vulnerable Sector Check / Criminal Record Check",
      "Additional Nova Scotia Health onboarding documents as required",
    ],
  },
];

export default assignments;